<bn-loading-overlay></bn-loading-overlay>
<div class="container">
  <form [formGroup]="formGroup" class="form">

    <div class="row mb-3">
        <div class="col">
        <h3>Editar Limite Adicional por Cesta</h3>
      </div>
      <div class="col-auto ms-auto">
        <button type="button" class="btn btn-danger me-2" (click)="voltarParaLista()">Fechar</button>
        <button class="btn btn-success no-margin"
          [disabled]="!formGroup.get('idLimite')?.value"
          (click)="editar() ">Editar</button>
      </div>
    </div>

    <div class="bn-form-group row">
      <div class="col-md-5">
        <label class="form-label" for="dataInicioProtocolo"><b>Limite Adicional</b></label>
        <select id="idLimite" class="form-select" formControlName="idLimite">

          <option *ngFor="let limite of limiteAdicional" [value]="limite.id">
            {{limite.nome}}
          </option>
        </select>
      </div>
    </div>
  </form>
</div>

